import moment from "moment";

const state = {
  eventlist: [],
  search: "",
  total: -1,
  page: 1,
  filter: [],
  date_range: {
    type: '',
    start: '',
    end: ''
  },
  month_events: [],
  categorylist: {},
  loading: false,
  selectedCategories: {},
  selectedMonth: moment().format("YYYY-MM"),
  isMonthView: false,
  isDateManuallySelected: false,
  navigationDirection: "",
}

export default state
